<div class="container">
  @for (attachment of attachments(); track attachment.name; let i = $index) {
  <div class="thumbnail-wrapper">
    <div class="thumbnail" [ngClass]="variant()" (click)="openFileViewer(i)" matTooltip="{{attachment.name}}">
      @if (attachment.type.includes(FILE_TYPES.Image)) {
      <img aria-label="image thumbnail" [src]="attachment.thumbnail_url" [alt]="attachment.name"
        class="thumbnail-preview thumbnail-image" />
      } @else {
      <div class="thumbnail-preview" [ngClass]="getSelectedFile(attachment).className">
        <mat-icon>{{getSelectedFile(attachment).icon}}</mat-icon>
      </div>
      }
      @if(attachment.file && variant() === 'large') {
      <p class="file-size">{{formatFileSize(attachment.file.size)}}</p>
      }
    </div>
    @if(!fileUploadService.isFileUploading() && !hideRemoveButton()) {
    <mat-icon (click)="removeFileHandler(i)" class="remove-button">delete</mat-icon>
    }
  </div>
  }
</div>